module.exports = __webpack_public_path__ + "static/media/empty-doc-placeholder.0ebf39bf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty-doc-placeholder.gif
// module id = 2169
// module chunks = 17